// FILE: src/lib/ga.js
export const GA_ID = 'G-65ZNMH8BF9'; // <-- put your Measurement ID here

export function pageview(path) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
}

export function gaEvent(name, params = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, params);
  }
}
